{
  "ts": 1747398486,
  "tsCommit": 1747398451,
  "repoName": "WebSignup",
  "branchName": "prod",
  "rev": "c32bceb",
  "ver": "20250516_1228_WebSignup_prod_c32bceb",
  "env": "production",
  "isBranchDeployment": false
}
